import { render, staticRenderFns } from "./InstallationDetail_DestinationDashboardSingle.vue?vue&type=template&id=3b2f4241&scoped=true&"
import script from "./InstallationDetail_DestinationDashboardSingle.vue?vue&type=script&lang=js&"
export * from "./InstallationDetail_DestinationDashboardSingle.vue?vue&type=script&lang=js&"
import style0 from "./InstallationDetail_DestinationDashboardSingle.vue?vue&type=style&index=0&id=3b2f4241&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f4241",
  null
  
)

export default component.exports